
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import { EnumVerifyCodeType } from '@xt/client/enums/user'
import Input from '../Input/index.vue'
import lodash from 'lodash'
import { Bind, Debounce } from 'lodash-decorators'

@Observer
@Component({
  components: {
    Input
  }
})
export default class Phone extends Vue {
  form: {
    phone: string
    qrcode: string
  } = {
    phone: '',
    qrcode: ''
  }

  sendSmsLock: boolean = false

  get EnumVerifyCodeType() {
    return EnumVerifyCodeType
  }

  get UserStore() {
    return this.$store.$storeUser
  }

  validateField(
    mode: 'submit' | 'codeCheck' = 'submit'
  ): Promise<{ code: string; field: string; msg: string } | { code: string; msg: string }> {
    return new Promise((resolve, reject) => {
      if (!this.form.phone) {
        resolve({
          code: 'error',
          field: 'phone',
          msg: '手机号不能为空'
        })
        return
      }

      const reg = /^1[3-9]\d{9}$/
      if (!reg.test(this.form.phone)) {
        resolve({
          code: 'error',
          field: 'phone',
          msg: '请输入正确的手机号'
        })
        return
      }

      if (!this.form.qrcode && mode === 'submit') {
        resolve({
          code: 'error',
          field: 'qrcode',
          msg: '验证码不能为空'
        })
        return
      }

      resolve({
        code: 'success',
        msg: '校验完成'
      })
    })
  }

  async getQrcode(callback: () => void) {
    try {
      if (this.sendSmsLock) return

      this.sendSmsLock = true

      // 校验手机号是否合法
      const res = await this.validateField('codeCheck')

      if (res.code === 'error') {
        this.$msg(res.msg)
        this.sendSmsLock = false
        return
      }

      await this.UserStore.onGetCode({
        device: this.form.phone,
        verifyCodeType: EnumVerifyCodeType.BindPhone
      })

      // 倒计时执行
      callback()
    } catch (error) {
      if (lodash.eq(error, false)) this.$msg(this.$EnumMessage.check_code_error)
    } finally {
      this.sendSmsLock = false
    }
  }

  @Debounce(300, { leading: true, trailing: false })
  @Bind()
  async onSubmit() {
    try {
      const res = await this.validateField()

      if (res.code === 'error') {
        this.$msg(res.msg)
        return
      }

      const { phone, qrcode } = this.form

      const checkCode = {
        device: phone,
        verifyCode: qrcode,
        verifyCodeType: EnumVerifyCodeType.BindPhone
      }

      await this.UserStore.onCheckCode(checkCode)

      await this.UserStore.onBindPhone({
        phoneNum: phone,
        verifyCode: qrcode
      })

      this.$msg(this.$EnumMessage.bind_success, 'info')

      return true
    } catch (error) {
      if (lodash.eq(error, false)) this.$msg(this.$EnumMessage.check_code_error)
    }
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
